// import { Link } from "@tanstack/react-router";
// import { buttonVariants } from "@workspace/web-ui/components/button";
// import { cn } from "@workspace/web-ui/lib/utils";

import { getRouteApi } from "@tanstack/react-router";
// import { Tabs, TabsContent, TabsList, TabsTrigger } from "@workspace/web-ui/components/tabs";
// import { QUESTION_LABELS } from "../../quick-actions/components/drawers/consultation-modal";
import { PatientDetailsConditional } from "~/features/dashboard/components/patient/patient-details-conditional";
// import { RecommendedTask } from "../recommended-task";
import { FormattedEncounter } from "../../types";
import { Button } from "@workspace/web-ui/components/button";
import { PlusIcon } from "lucide-react";
import TaskContainer from "~/features/dashboard/components/tasks/task-container";
import { Tasks } from "~/features/dashboard/components/tasks";
import { NotesContainer } from "~/features/dashboard/components/notes";
import { useState } from "react";
import { ConsultationStatus } from "../../../quick-actions/components/consultation-status";
import { useSendActionNeededMutation } from "../../../patient-logs/api/mutations";
import { toast } from "sonner";

// const COLORS = {
//     TEXT_PRIMARY: '#2D2F35',
//     TEXT_SECONDARY: '#667085',
// } as const;

// Skeleton loader for consultation details
export function ConsultationDetailsSkeleton() {
    return (
        <div className="flex flex-col w-full h-full bg-white rounded-[24px] border border-[#0404041A] overflow-auto p-4 sm:py-[16px] sm:px-[32px] animate-pulse gap-4">
            <div className="h-8 w-2/3 bg-gray-200 rounded mb-2" />
            <div className="flex flex-col sm:flex-row gap-3 sm:gap-2 items-start sm:items-center justify-between mb-1 w-full">
                <div className="flex flex-col gap-2 w-full sm:w-auto">
                    <div className="h-8 w-1/2 bg-gray-200 rounded mb-1" />
                    <div className="flex gap-2">
                        <div className="h-4 w-20 bg-gray-200 rounded" />
                        <div className="h-4 w-12 bg-gray-200 rounded" />
                        <div className="h-4 w-10 bg-gray-200 rounded" />
                    </div>
                </div>
            </div>
            <div className="flex gap-2 mb-4">
                <div className="h-6 w-24 bg-gray-200 rounded" />
                <div className="h-6 w-16 bg-gray-200 rounded" />
            </div>
            <div className="flex flex-col w-full text-left pb-3 mb-6 gap-2">
                <div className="h-5 w-1/3 bg-gray-200 rounded mb-2" />
                <div className="grid grid-cols-[150px_1fr] gap-8">
                    <div className="flex flex-col gap-2">
                        <div className="h-4 w-16 bg-gray-200 rounded" />
                        <div className="h-4 w-20 bg-gray-200 rounded" />
                    </div>
                    <div className="flex flex-col gap-2">
                        <div className="h-4 w-20 bg-gray-200 rounded" />
                        <div className="h-4 w-24 bg-gray-200 rounded" />
                    </div>
                </div>
            </div>
            <div className="flex flex-col gap-3 w-full p-4 text-left rounded-[16px] border border-[#0404041A] pb-3 mb-6">
                <div className="h-6 w-1/3 bg-gray-200 rounded mb-2" />
                <div className="grid grid-cols-[min-content_1fr] text-sm gap-8">
                    <div className="flex flex-col gap-2">
                        {[...Array(5)].map((_, i) => <div key={i} className="h-4 w-10 bg-gray-200 rounded" />)}
                    </div>
                    <div className="flex flex-col gap-2 font-medium">
                        {[...Array(5)].map((_, i) => <div key={i} className="h-4 w-16 bg-gray-200 rounded" />)}
                    </div>
                </div>
            </div>
            <div className="w-full flex gap-4 bg-[#EBF0FB] p-4 rounded-[8px]">
                <div className="h-10 w-1/2 bg-gray-200 rounded" />
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-center w-full p-3 mt-4 gap-2">
                <div className="h-6 w-1/3 bg-gray-200 rounded" />
                <div className="h-10 w-24 bg-gray-200 rounded" />
            </div>
            <div className="mb-5 w-full flex flex-col gap-2">
                <div className="h-8 w-full bg-gray-200 rounded" />
                <div className="h-8 w-2/3 bg-gray-200 rounded" />
            </div>
        </div>
    );
}

// This component contains the actual consultation details content
export const ConsultationDetailsAction = ({ encounter }: { encounter: FormattedEncounter }) => {
    const routeApi = getRouteApi("/(dashboard)/dashboard/$program");
    const { program } = routeApi.useParams();
    const [isTaskCardOpen, setIsTaskCardOpen] = useState(false);
    const { mutate: sendActionNeeded, isPending: sendActionpending } = useSendActionNeededMutation();

    return (
        <div className="flex flex-col w-full h-full bg-[#FFFFFF] rounded-[24px] border border-[#0404041A] overflow-auto p-4 sm:py-[16px] sm:px-[32px]">
            {/* Patient info section */}
            <div className="flex flex-col h-full items-start gap-4 mb-5">
                <div className="flex flex-col gap-2 w-full flex-wrap mt-4">
                    {/* <div
                            className={cn(
                                "text-xs px-2 py-1 rounded-full flex gap-2 items-center w-fit bg-[#FFA7261A] text-[#FFA726]",
                            )}
                            aria-label={`consultation status: urgent`}
                        >
                            <span>Urgent</span>
                        </div> */}
                    <ConsultationStatus program={program} />
                    <div className="flex">
                        <h1 id="consultation-details-title" className="text-xl flex font-medium">{encounter.title}</h1>
                        {program === "urgent-care" ? (
                                    encounter.patient.urgent_care_onboarded && encounter.patient.identity_verified && (
                                        <div className="flex-shrink-0 mt-1 sm:mt-0">
                                            <img
                                                src="/icons/check.svg"
                                                alt="timeline"
                                                className="w-4 h-4 sm:w-5 sm:h-5"
                                            />
                                        </div>
                                    )
                                ) : (
                                    encounter.patient.medical_plan?.payment_status === "paid" &&
                                    encounter.patient.glp1_guide_accepted &&
                                    encounter.patient.identity_verified &&
                                    encounter.patient.supplementary_health_assessment &&
                                    Object.keys(encounter.patient.supplementary_health_assessment).length > 0 && (
                                        <div className="flex-shrink-0 mt-1 sm:mt-0">
                                            <img
                                                src="/icons/check.svg"
                                                alt="timeline"
                                                className="w-4 h-4 sm:w-5 sm:h-5"
                                            />
                                        </div>
                                    )
                                )}
                    </div>
                </div>

                {program === "urgent-care" ? (
                    <div className="flex gap-8 w-full items-start mb-4">
                        <div className="flex flex-col space-y-1 w-1/2">
                            <p className="text-[#464B55] text-xs">Submitted:</p>
                            <p className="text-[#1A202C] text-sm font-medium">{encounter.createdAt}</p>
                        </div>
                        <div className="flex flex-col space-y-1 w-1/2">
                            <p className="text-[#464B55] text-xs">Program:</p>
                            <p className="text-[#1A202C] text-sm font-medium">
                                Urgent Care
                            </p>
                        </div>
                    </div>
                ) : (
                    <div className="flex gap-8 w-full items-start mb-4">
                        <div className="flex flex-col space-y-1 w-1/2">
                            <p className="text-[#464B55] text-xs">Request Date:</p>
                            <p className="text-[#1A202C] text-sm font-medium">{encounter.createdAt}</p>
                        </div>
                        <div className="flex flex-col space-y-1 w-1/2">
                            <p className="text-[#464B55] text-xs">Program:</p>
                            <p className="text-[#1A202C] text-sm font-medium">
                                Weight Loss
                            </p>
                        </div>
                        <div className="flex flex-col space-y-1 w-1/2">
                            <p className="text-[#464B55] text-xs">Consultation:</p>
                            <p className="text-[#1A202C] capitalize text-sm font-medium">Express</p>
                        </div>
                    </div>
                )}


                <PatientDetailsConditional encounter={encounter} program={program} />

                {program === "urgent-care" && encounter.patient.urgent_care_onboarded && (
                            <NotesContainer
                                encounterId={encounter.encounterId}
                                patientId={encounter.patient.id}
                                notes={encounter.notes}
                                icd={encounter.session?.icd10_code}
                            />
                        )
                }

                {/* Notes Section */}
                {program === "weight-loss" &&
                    encounter?.patient?.medical_plan?.payment_status === "paid" &&
                    encounter?.patient?.glp1_guide_accepted &&
                    encounter?.patient?.identity_verified &&
                    encounter?.patient?.supplementary_health_assessment &&
                    Object.keys(encounter.patient.supplementary_health_assessment).length > 0 && (
                        <NotesContainer
                            encounterId={encounter.encounterId}
                            patientId={encounter.patient.id}
                        />
                    )
                }

                {/* Recommended Tasks */}
                {program === "weight-loss" && (
                    encounter?.patient?.medical_plan?.payment_status === "paid" &&
                    encounter?.patient?.glp1_guide_accepted &&
                    encounter?.patient?.identity_verified &&
                    encounter?.patient?.supplementary_health_assessment &&
                    Object.keys(encounter.patient.supplementary_health_assessment).length > 0 ? (
                        <>
                            <div className="flex justify-between items-center w-full p-3">
                                <h2 className="font-semibold text-xl">Recommended Tasks</h2>
                                <Button
                                    className="button-primary !bg-[#4272DD] h-[44px] !text-white flex gap-2 items-center !shadow-none w-fit ml-auto !border-none"
                                    onClick={() => setIsTaskCardOpen(true)}
                                >
                                    <PlusIcon className="w-4 h-4 text-white" />
                                    Add
                                </Button>
                            </div>

                            <div className="mb-5 w-full">
                                {isTaskCardOpen && (
                                    <Tasks open={isTaskCardOpen} onOpenChange={setIsTaskCardOpen} id={encounter.encounterId} className="bg-[#EFF0F2]" />
                                )}

                                <TaskContainer encounterId={encounter.encounterId} patientId={encounter.patient.id} />
                            </div>
                        </>
                    ) : (
                        <div className="flex items-center bg-[#F0F5FF] rounded-lg px-4 py-2 justify-between w-full">
                            <p className="text-sm text-[#1A202C]">
                                Patient must be verified
                            </p>
                            <Button
                                className="button-primary !bg-[#4272DD] h-[44px] !text-white flex gap-2 items-center !shadow-none w-fit !border-none"
                                onClick={async () => {
                                    try {
                                        await sendActionNeeded({ patient_id: encounter.patient.id });
                                        toast.success("Reminder sent to patient to complete verification.");
                                    } catch (error) {
                                        toast.error("Failed to send reminder.");
                                    }
                                }}
                                disabled={sendActionpending}
                            >
                                {sendActionpending && (
                                    <svg className="animate-spin h-4 w-4 mr-2 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                        <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                        <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"></path>
                                    </svg>
                                )}
                                Send a Reminder
                            </Button>
                        </div>
                    )
                )}
            </div>
        </div>
    );
};


